import script from "./ComplianceSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComplianceSection.vue?vue&type=script&lang=ts&setup=true"

import "./ComplianceSection.vue?vue&type=style&index=0&id=44b296cc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b296cc"]])

export default __exports__